module.exports = __webpack_public_path__ + "img/whatsNewBurst.50f480c0.png";